import { validationMessage } from 'vuelidate-messages'
import { required, email } from 'vuelidate/lib/validators'
import { messages } from '@lib/validation-helpers'

export const validations = {
  validations: {
    email: { required, email },
    password: { required }
  },

  methods: {
    $v_displayMessage: validationMessage(messages),
    $v_validationPass() {
      this.$v.$touch()
      return !this.$v.$invalid
    }
  }
}
